import type { FeatureFlags } from '~/types/featureFlagsProvider';

interface FeatureFlagsConfig {
  base: FeatureFlags;
  clusters?: Record<string, FeatureFlags>;
}

// apps/phoenix dir. PHOENIX_APP_DIR overrides for host-native (nix) runs where the
// repo is not mounted at /var/www; the default keeps container behaviour unchanged.
// eslint-disable-next-line node/no-process-env
const PHOENIX_APP_DIR = process.env.PHOENIX_APP_DIR ?? '/var/www/apps/phoenix';

export const getBootstrapFeatureFlags = async (countryCode?: string): Promise<FeatureFlags> => {
  const fs = await import('node:fs/promises');

  const defaultJson: FeatureFlagsConfig = JSON.parse(await fs.readFile(`${PHOENIX_APP_DIR}/.feature-flags.json`, 'utf-8'));

  const clusterSpecific = countryCode ? (defaultJson.clusters?.[countryCode] ?? {}) : {};

  try {
    const testingOverridesJson: FeatureFlags = JSON.parse(await fs.readFile(`${PHOENIX_APP_DIR}/.feature-flags.testing.json`, 'utf-8'));
    // An E2E run resets the overrides between tests, and a run that dies mid-way leaves the empty
    // file behind. A file that overrides nothing is not a testing session — treating it as one
    // silently kills every dev override for whoever picks the checkout up next.
    if (Object.keys(testingOverridesJson).length > 0) {
      return {
        ...defaultJson.base,
        ...clusterSpecific,
        ...testingOverridesJson,
      };
    }
  }
  // eslint-disable-next-line unused-imports/no-unused-vars
  catch (_error) {
    // do nothing
  }

  try {
    const devOverridesJson: FeatureFlags = JSON.parse(await fs.readFile(`${PHOENIX_APP_DIR}/.feature-flags.dev.json`, 'utf-8'));
    return {
      ...defaultJson.base,
      ...clusterSpecific,
      ...devOverridesJson,
    };
  }
  // eslint-disable-next-line unused-imports/no-unused-vars
  catch (_error) {
    // do nothing
  }

  return {
    ...defaultJson.base,
    ...clusterSpecific,
  };
};
